import {
    CodeDescriptionRestDto,
    ContentPageRestDto,
    WysiwygContentPageRestDto,
    WysiwygContentPageRowRestDto
} from "@/api/pharma-cms-content-page/models";
import {StatusEnum} from "@/api/enums/status-enum";

export class WysiwygContentPageRestDtoModel implements WysiwygContentPageRestDto {
    id: string;
    content_id: string;
    type?: CodeDescriptionRestDto | null;
    cp?: ContentPageRestDto | null;
    rows: WysiwygContentPageRowRestDto[];

    constructor(id: string, content_id: string, rows: WysiwygContentPageRowRestDto[]) {
        this.id = id;
        this.content_id = content_id;
        this.rows = rows;
    }

    /**
     * An empty page, used while nothing is loaded yet and for the "create the homepage / named page
     * first" states, where the screen renders before any page exists on the backend.
     */
    static createWithDefaults(): WysiwygContentPageRestDtoModel {
        const model: WysiwygContentPageRestDtoModel = new this('', '', []);

        model.type = {code: '', description: ''} as CodeDescriptionRestDto;
        model.cp = {
            status_code: StatusEnum.PUBLISHED,
            name: '',
            is_published_on_home: false,
        } as ContentPageRestDto;

        return model;
    }
}
